export default function FormErrors(props: any) {
  if (!props.errors || !props.errors.length) {
    return null;
  }
  const errors = props.errors.filter((error: any) =>
    props.param ? error.param === props.param : error.param == null
  );
  if (!errors.length) {
    return null;
  }
  return (
    <ul style={{ color: "darkred" }}>
      {errors.map((e: any, i: any) => (
        <li key={i}>{e.message}</li>
      ))}
    </ul>
  );
}
